import React, { Component, Fragment } from "react";
import { BounceLoader } from "react-spinners";
import { Field } from "redux-form";
import classNames from "classnames";
import { getError } from "../../common/lib/getError";
import RenderField from "../../common/components/Form/RenderField";
import Button from "../../common/components/Button";
import {
  email,
  phone,
  normalizePhone,
  normalizeDob,
  required,
  validatePassword,
  validateDob,
  isEmpty,
  requiredCheckbox,
  normalizeName,
} from "../../common/lib/validation";

import "../../../style/index.css";
import "./register.css";

const termsAndConditionsComponent = () => (
  <Fragment>
    I accept the{" "}
    <a
      href="https://nylottery.ny.gov/legal/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open in new tab: Terms and Conditions"
    >
      Terms and Conditions
    </a>
    *
  </Fragment>
);

const MOBILE_PHONE_HELP_TEXT =
  "Confirming account identity requires SMS text messages. Please provide your mobile number to proceed.";

class RegisterForm extends Component {
  constructor(props) {
    super(props);
    this.confirmPassword = this.confirmPassword.bind(this);
  }

  confirmPassword(value) {
    const { password } = this.props;
    if (!isEmpty(value) && value !== password) {
      return "Passwords must match";
    } else if (isEmpty(value)) {
      return "Required";
    }
    return null;
  }

  render() {
    const {
      submitFormFn,
      formSubmissionError,
      formRef,
      isFetching,
      registrationFailed,
      errorDetail,
      statusCode,
    } = this.props;

    return (
      <form className="needs-validation" noValidate ref={formRef}>
        <div className="personal-info-wrap personal-info-wrap--first">
          <h2 className="form-header">Account Setup</h2>
          <Field
            name="firstName"
            type="text"
            component={RenderField}
            label="First Name*"
            validate={required}
            normalize={normalizeName}
          />
          <Field
            name="lastName"
            type="text"
            component={RenderField}
            label="Last Name*"
            validate={required}
            normalize={normalizeName}
          />
          <Field
            name="birthdate"
            type="tel"
            component={RenderField}
            label="Date of Birth*"
            normalize={normalizeDob}
            placeholder="MM/DD/YYYY"
            inputmode="tel"
            validate={validateDob}
          />
          <Field
            name="isOver18"
            type="checkbox"
            component={RenderField}
            label="I certify that I'm at least 18 years old*"
            className="hanging-checkbox"
            validate={requiredCheckbox}
          />
          <Field
            name="phone"
            type="tel"
            component={RenderField}
            label="Mobile Phone Number*"
            placeholder="(XXX) XXX-XXXX"
            validate={phone}
            normalize={normalizePhone}
            prepend="phone"
            className="has-prepend"
            inputmode="tel"
            helpText={MOBILE_PHONE_HELP_TEXT}
          />
          <Field
            name="email"
            type="text"
            component={RenderField}
            label="Email Address*"
            placeholder="This will be your username"
            autocorrect="off"
            autocapitalize="none"
            validate={email}
            prepend="mail"
            className="has-prepend"
            fieldId="sso-email"
          />
          <Field
            name="password"
            type="password"
            component={RenderField}
            label="Password*"
            validate={validatePassword}
            helpText="Your password must be 14-20 characters long, contain letters and at least one non-alphabetical character, and must not contain spaces or emoji."
          />
          <Field
            name="confirmPassword"
            type="password"
            component={RenderField}
            label="Confirm Password*"
            validate={this.confirmPassword}
          />
          <Field
            name="acceptedTermsAndConditions"
            type="checkbox"
            component={RenderField}
            label={termsAndConditionsComponent()}
            validate={requiredCheckbox}
          />
          <Field
            className={classNames("last-checkbox", {"last-checkbox--error": formSubmissionError || registrationFailed})}
            name="newsletter"
            type="checkbox"
            component={RenderField}
            label="Sign me up for NYL+ communications"
          />

          {registrationFailed && errorDetail && (
            <p
              id="register-api-error"
              className="submit-error"
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              tabIndex={-1}
              dangerouslySetInnerHTML={{ __html: getError(errorDetail, statusCode) }}
            />
          )}
          {formSubmissionError && (
            <p
              id="register-validation-summary"
              className="submit-error"
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              tabIndex={-1}
            >
              Please see required fields above to complete registration.
            </p>
          )}

          <div className="button-wrap">
            {isFetching ? (
              <div className="loading-wrapper">
                <BounceLoader color="#084267" />
              </div>
            ) : (
              <Button
                label="Register"
                onClickFn={submitFormFn}
                className={classNames("nyl-button", {"button-error": formSubmissionError || registrationFailed})}
                id="register-button"
              />
            )}
          </div>
          <noscript>
            <img
              src="https://ad.doubleclick.net/ddm/activity/src=5139115;type=nylot0;cat=nylre0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?"
              width="1"
              height="1"
              alt=""
            />
          </noscript>
        </div>
      </form>
    );
  }
}

export default RegisterForm;
